/**
 * Deze klasse handelt het beheer van de locations af (deze zijn alleen aan de een app_user_id gekoppeld)
 *
 * @history
 * 24 juli 2023
 * Tonen aantal actieve locaties en deselect/select all
 *
 * 12 juni 2023
 * met active toggle
 *
 * 17 november 2022
 * has_image, image_url
 *
 * 7 november 2022
 * Basis implementatie
 *
 * @todo    kleuren kiezen
 * @todo    afbeelding kiezen
 *
 */

import React from "react";
import {LocationForm} from "./forms/LocationForm";



export class LocationsManager extends React.Component {
    constructor(props) {
        super(props);

        this.state =
        {
            loaded : false,
            records: [],
            show_add: false,
            show_edit:false,
            curr_record_index:-1,
            tot_active: -1,

           curr_record:
               {
                   id:-1,
                   title:"",
                   has_image:'N',
                   image_url:'',
                   def_location_image_id:0
               }
        };

        this.toggleLocationActiveClicked = this.toggleLocationActiveClicked.bind(this);
        this.refreshRecords = this.refreshRecords.bind(this);
        this.handleForm = this.handleForm.bind(this);
        this.addClicked = this.addClicked.bind(this);
        this.editClicked = this.editClicked.bind(this);
        this.deleteClicked = this.deleteClicked.bind(this);
        this.deSelectAllClicked = this.deSelectAllClicked.bind(this);
        this.selectAllClicked = this.selectAllClicked.bind(this);


    }

    addClicked()
    {
       this.setState(
           {
               show_add: true,
           }
       )
    }

    selectAllClicked()
    {
        const formData = new FormData();
        formData.append("session_id", window.app.logboek.id);
        const requestOptions = {
            method: 'POST',
            body: formData
        };
        fetch("/select_all_locations", requestOptions)
            .then(response => response.json())
            .then(json => {
                if (json.status == "ok") {


                    this.refreshRecords();


                } else {
                    console.log("?");
                }
            });
    }

    deSelectAllClicked()
    {
        const formData = new FormData();
        formData.append("session_id", window.app.logboek.id);
        const requestOptions = {
            method: 'POST',
            body: formData
        };
        fetch("/deselect_all_locations", requestOptions)
            .then(response => response.json())
            .then(json => {
                if (json.status == "ok") {

                    this.refreshRecords();

                } else {
                    console.log("?");
                }
            });
    }



    editClicked(p_index)
    {
        this.setState(
            {
                show_edit: true,
                curr_record:
                    {
                        id: this.state.records[p_index].id,
                        title: this.state.records[p_index].title,
                        has_image:this.state.records[p_index].has_image,
                        image_url:this.state.records[p_index].image_url,
                        def_location_image_id: this.state.records[p_index].def_location_image_id

                    },
                curr_record_index:  p_index

            }
        )
    }

    deleteClicked(p_index)
    {
        if (window.confirm("Deze hoek met eventuele gegevens echt verwijderen?"))
        {
            const formData = new FormData();

            formData.append("location_id", this.state.records[p_index].id);

            const requestOptions = {
                method: 'POST',
                body: formData
            };

            fetch("/delete_location", requestOptions)
                .then(response => response.json())
                .then(logs_json => {
                    if (logs_json.status == "ok") {


                        this.refreshRecords();


                    } else {
                        console.log("?");
                    }
                });
        }
    }

    async handleForm(p_reload, p_group)
    {
        if (p_reload)
        {
            await this.refreshRecords();
            this.setState({
                show_add: false,
                show_edit: false
            });

        }
        else
        {
            this.setState({
                show_add: false,
                show_edit: false
            });
        }

    }

    async refreshRecords()
    {
        const formData = new FormData();

        if (this.props.session_active)
        {
            formData.append("with_active", "Y");
            formData.append("session_id", window.app.logboek.id);
        }
        else
        {
            formData.append("with_active", "N");
        }




        const requestOptions = {
            method: 'POST',
            body:formData
        };

        await fetch("/get_locations", requestOptions)
            .then(response => response.json())
            .then(json =>
            {
                if (json.status == "ok")
                {
                    if (this.props.session_active)
                    {
                        this.setState({
                            records: json.data,
                            loaded: true,
                        tot_active : json.data.reduce((count, rec) => (rec.is_active == "Y" ? count + 1 : count), 0)
                        });
                    }
                    else
                    {
                        this.setState({
                            records: json.data,
                            loaded: true
                        });
                    }

                }
                else
                {
                    console.log("?");
                }
            });
    }

    showActiveState(p_record_index)
    {
        if (this.state.records[p_record_index].is_active == "Y")
        {
            return (
                <a href="javascript:void(0)"  onClick={() => this.toggleLocationActiveClicked(this.state.records[p_record_index].id, 'N')}><img src={"/digibord/assets/svgs/checked_red.svg"} style={{"width":"100%"}}  /></a>
            )
        }

        return (
            <a href="javascript:void(0)"  onClick={() => this.toggleLocationActiveClicked(this.state.records[p_record_index].id, 'Y')}><img src={"/digibord/assets/svgs/unchecked_red.svg"} style={{"width":"100%"}}  /></a>
        )
    }

    toggleLocationActiveClicked(p_location_id, p_is_active)
    {
        const formData = new FormData();
        formData.append("session_id", window.app.logboek.id);
        formData.append("is_active", p_is_active);

        formData.append("location_id", p_location_id);

        const requestOptions = {
            method: 'POST',
            body:formData
        };

        fetch("/activate_location", requestOptions)
            .then(response => response.json())
            .then(json =>
            {
                if (json.status == "ok")
                {
                    this.refreshRecords();
                }
                else
                {
                    console.log("?");
                }
            });

    }

    componentDidMount() {
        this.refreshRecords();
    }



    render() {
        return (
            <div className={"tool__content__location__wrapper"}>
                <h1>Beheer van de hoeken</h1>
                <div className={"tool__content__location__content"}>
                    <p>Je kunt hieronder alle hoeken beheren.   {this.props.session_active &&
                        (
                            <> Je kan maximaal 8 hoeken selecteren.</>
                        )}
                    </p>
                </div>

                {!this.state.loaded && !this.state.show_add && !this.state.show_edit  &&
                    (
                        <p style={{"text-align":"center"}}>Even geduld AUB, alle gegevens worden ingeladen</p>

                    )}


                {this.state.loaded && !this.state.show_add && !this.state.show_edit &&
                    (
                        <>
                        <div className={"tool__locations__table"} style={{height:"25vh"}}>
                        {this.state.records.map( (record, record_index) =>
                                (
                                    <div className={"tool__locations__table__row"}>
                                        <div className={"tool__locations__table__cell__title"}>
                                            {record.title}
                                            <a href="javascript:void(0)"  onClick={() => this.deleteClicked(record_index)}><img src={"/digibord/assets/svgs/ui/trash_white.svg"}  className={"ui_icon_small"} style={{float: "right"}}/></a>

                                            <a href="javascript:void(0)"  onClick={() => this.editClicked(record_index)}><img src={"/digibord/assets/svgs/ui/pencil_white.svg"}  className={"ui_icon_small"} style={{float: "right"}}/></a>
                                         </div>


                                        {this.props.session_active &&
                                            (
                                                <div className={"tool__locations__table__cell__is_active"}> {this.showActiveState(record_index)}</div>
                                            )}

                                        <div className={"tool__locations__table__cell__image"}   style={record.has_image == "Y" ? {
                                            "background-image": "url('" + record.image_url + "')",
                                            "background-size": "contain",
                                            "background-repeat":"no-repeat",
                                            "background-position":"center",
                                        } : {}}>


                                            {record.has_image == 'N' &&
                                                (
                                                    <>&nbsp;</>
                                                )
                                            }
                                        </div>

                                    </div>
                                )
                            )}

                        </div>

                            <p>
                                <a href="javascript:void(0)" className={"button"} onClick={() => this.addClicked()}>Maak een hoek aan</a>
                                {this.props.session_active &&
                                    (
                                        <>
                                            <a href="javascript:void(0)" className={"button"} onClick={() => this.selectAllClicked()}>Selecteer alle hoeken</a>
                                            <a href="javascript:void(0)" className={"button"} onClick={() => this.deSelectAllClicked()}>Deselecteer alle hoeken</a>

                                            {this.state.tot_active > 8 &&
                                                (
                                                    <><span className="error">Let op, je kan niet meer dan 8 hoeken selecteren.</span></>
                                                )}
                                        </>
                                    )
                                }
                            </p>
                        </>
                    )}


                {this.state.show_add &&
                    (
                        <LocationForm finished_callback = {this.handleForm} action={"add"}/>
                    )}

                {this.state.show_edit &&
                    (
                      <LocationForm finished_callback = {this.handleForm} record={this.state.curr_record}  action={"edit"}/>
                    )}





            </div>

        );
    }

}
